// Intent: [Journey] [Trust]
import React from "react";
import { AUSTEN_EMAIL } from "../config";
import { ButtonLink } from "../components/shared/ButtonLink";
import { CutPlan } from "../components/shared/CutPlan";
function NotFoundPage() {
  return <main id="main-content" className="relative grid min-h-[62vh] place-items-center overflow-hidden bg-pfpc-offwhite py-16" data-id="element-440" data-mp="2xtii47sbhc0v">
      <CutPlan className="absolute inset-0 h-full w-full opacity-45" data-id="element-441" data-mp="2szxkigumyk27" />
      <div className="container-shell relative" data-id="element-442" data-mp="36s4309l9h34t">
        <div className="max-w-2xl border border-pfpc-navy/15 bg-pfpc-offwhite p-7 md:p-12" data-id="element-443" data-mp="31ukmf313ce9p">
          <p className="section-label text-pfpc-orange" data-id="element-444" data-mp="3grl22860cirt">Page not found · 404</p>
          <h1 className="mt-4 font-heading text-[38px] font-extrabold leading-[1.08] text-pfpc-navy md:text-[52px]" data-id="element-445" data-mp="3gpidztof0zpq">
            This path is not part of the current site.
          </h1>
          <p className="mt-5 max-w-xl text-[17px] leading-7 text-pfpc-navy/70" data-id="element-446" data-mp="1mdtynqe9uv4t">
            Return to the homepage, or email the PFPC team if you were looking for ordering information that is not listed yet.
          </p>
          <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap" data-id="element-447" data-mp="wa5x1w885j67">
            <ButtonLink href="/" data-id="element-448" data-mp="10bhma0n6s2dv">Return to homepage</ButtonLink>
            <ButtonLink href={`mailto:${AUSTEN_EMAIL}`} variant="secondary" data-id="element-449" data-mp="15bvnayqdec2e">Email the Team</ButtonLink>
          </div>
        </div>
      </div>
    </main>;
}
export { NotFoundPage };